export default __webpack_public_path__ + "b84b1c8d3711095d1141f01dcd8a1c32.svg";